/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Station_Fleet_Moving_CountInputs */

const vi_station_fleet_moving_count = /** @type {(inputs: Station_Fleet_Moving_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} xe đang chạy`)
};

/**

* @param {Station_Fleet_Moving_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_fleet_moving_count = /** @type {((inputs: Station_Fleet_Moving_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Fleet_Moving_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_fleet_moving_count(inputs)
});